import { 
    UPDATE_CV_SKILLS,
    UPDATE_CV_SKILLS_SUCCESS,
    UPDATE_CV_SKILLS_ERROR
} from '../../store/constants';

const initalState = {
    error: false,
    loading: false,
    success: false,
}

const reducer = (state = initalState, action) => {
    switch (action.type) {
        case UPDATE_CV_SKILLS:
            return {...state, loading: true, error: false, success: false };
        case UPDATE_CV_SKILLS_SUCCESS:
            return {...state, loading: false, success: true };
        case UPDATE_CV_SKILLS_ERROR: 
            return {...state, loading: false, error: true };
        default: 
            return state;
    }
}

export default reducer;